import { Injectable } from '@angular/core';
import moment from 'moment';

@Injectable()
export class TimezoneHelper {
    getTimezoneData(timezoneName: string): moment.MomentZone {
        return moment.tz.zone(timezoneName);
    }

    getOffsetMinutes(timezone: moment.MomentZone, date: moment.Moment = moment()): number {
        return timezone.utcOffset(date.valueOf());
    }

    getOffsetString(timezone: moment.MomentZone, date: moment.Moment = moment()) {
        const offsetMinutes = this.getOffsetMinutes(timezone, date);
        const duration = moment.duration(offsetMinutes, 'minutes');
        const hh = Math.abs(
            duration.years() * (365 * 24) +
                duration.months() * (30 * 24) +
                duration.days() * 24 +
                duration.hours()
        );
        const mm = Math.abs(duration.minutes());
        return `${offsetMinutes <= 0 ? '+' : '-'}${hh.toString().padStart(2, '0')}:${mm
            .toString()
            .padStart(2, '0')}`;
    }
}
